// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const AllowedReturnStatus = t.struct({
    description: t.String,
    id: t.String,
    parentId: t.String
}, {
    name: 'AllowedReturnStatus',
    strict: true
});

export const getDefaultState = () => new AllowedReturnStatus({
    description: '',
    id: '',
    parentId: ''
});

export default AllowedReturnStatus;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/allowed-return-status.js